module.exports = "<div class=c-day-select> <div class=c-day-select__list ng-if=$ctrl.days ng-model=$ctrl.day> <ui-select ng-model=$ctrl.day uis-open-close=$ctrl.updateValue(isOpen)> <ui-select-match placeholder=\"Spa Day Selector\"> {{ $select.selected.name }} </ui-select-match> <ui-select-choices repeat=\"day.id as day in $ctrl.days | filter: $select.search track by $index\"> <div ng-bind-html=\"day.name | highlight: $select.search\"></div> <small>{{ day.category }}</small> </ui-select-choices> </ui-select> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/app/modules/days/views/day.single.select.html
// module id = 707
// module chunks = 0